
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/financial",
      function () {
        return require("private-next-pages/financial/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/financial"])
      });
    }
  